import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import ImageThumbHtmlView from './ImageHtml';
import MinimalDumbo from '../../../../DeviationViews/Dumbo/EditorDumbo';
const ImageThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(ImageThumbHtmlView, props);
    }
    /* In editor we make the background transparent to avoid overlapping with custom backgrounds */ return /*#__PURE__*/ React.createElement(MinimalDumbo, _object_spread({
        useBackgroundColor: false
    }, props));
};
ImageThumbView.displayName = 'ImageThumbView';
export default ImageThumbView;
